import { render, staticRenderFns } from "./DataImport.vue?vue&type=template&id=3fb9c7e2&scoped=true"
import script from "./DataImport.vue?vue&type=script&lang=js"
export * from "./DataImport.vue?vue&type=script&lang=js"
import style0 from "./DataImport.vue?vue&type=style&index=0&id=3fb9c7e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb9c7e2",
  null
  
)

export default component.exports